import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'administration',
    loadChildren: () => import('./modules/administration/administration.module').then(m => m.AdministrationModule)
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./modules/maintenance/maintenance.module').then(m => m.MaintenanceModule)
  },
  {
    path: 'project',
    loadChildren: () => import('./modules/project/project.module').then(m => m.ProjectModule)
  },
  {
    path: 'llw',
    loadChildren: () => import('./modules/llw/llw.module').then(m => m.LlwModule)
  },
  {
    path: 'llw-export',
    loadChildren: () => import('./modules/llw-export/llw-export.module').then(m => m.LlwExportModule)
  },
  {
    path: 'report',
    loadChildren: () => import('./modules/report/report.module').then(m => m.ReportModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
